import { render, staticRenderFns } from "./AbkListWithSub.vue?vue&type=template&id=22503e88&scoped=true&"
import script from "./AbkListWithSub.vue?vue&type=script&lang=js&"
export * from "./AbkListWithSub.vue?vue&type=script&lang=js&"
import style0 from "./AbkListWithSub.vue?vue&type=style&index=0&id=22503e88&scoped=true&lang=scss&"
import style1 from "./AbkListWithSub.vue?vue&type=style&index=1&id=22503e88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22503e88",
  null
  
)

export default component.exports